import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { lighten, useTheme } from '@mui/material/styles'
import { FormSectionProps } from '../../interfaces/form'
import { useForm } from 'react-final-form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormRadio from '../../components/FormRadio'

const radioStyle = {
  paddingBottom: 0,
  display: 'none',
}

const radioOverrideMuiStyle = {
  '&.MuiRadio-root': {
    '&.Mui-checked + span': {
      backgroundColor: `primary.main`,
      color: '#FFF !important',
    },
  },
}

const textStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  display: 'inline-flex',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: 'primary.main',
  marginTop: 0,
  marginRight: '6px',
  marginBottom: '10px',
  fontWeight: 'bold',
  verticalAlign: 'top',
  width: '100%',
  height: '100%',
  minHeight: 80,
  cursor: 'pointer',
}

const Loans = ({ validate }: FormSectionProps) => {
  const form = useForm()
  const theme = useTheme()

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 8 }}>
            Do you have any outstanding loans or credit agreements?
          </Typography>
          <Grid container spacing={2} sx={{ mb: 14 }}>
            <Grid item xs={12} md={6}>
              <label htmlFor="loans-yes" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="loans-yes"
                  name="loans"
                  value="Yes"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('loans', 'Yes')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Yes
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="loans-no" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="loans-no"
                  name="loans"
                  value="No"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('loans', 'No')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  No
                </Typography>
              </label>
            </Grid>
          </Grid>
          <Typography variant="body1" fontSize={16}>
            We don't need to know about borrowing less than £900, credit cards,
            store cards, or overdrafts.
          </Typography>
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default Loans
